import React from "react";
import { Link } from "react-router-dom";
import { ArrowRightIcon } from "lucide-react";
import { qualityDocuments } from "../../data/process";
import { images } from "../../data/images";
export function QualitySection() {
  return <section aria-labelledby="quality-title" className="border-t border-line bg-cream" data-id="element-188" data-mp="ob2h59mmrqq2">
      <div className="mx-auto grid max-w-[1400px] gap-14 px-5 py-24 md:px-10 md:py-32 lg:grid-cols-12" data-id="element-189" data-mp="jcsl6wt30m3e">
        <div className="lg:col-span-5" data-id="element-190" data-mp="fdjqnpq7wk6s">
          <h2 id="quality-title" className="font-display text-5xl leading-[1.02] tracking-tight text-ink md:text-6xl" data-id="element-191" data-mp="acvp4a4d4kyb">
            Un dossier complet, livré avec chaque lot.
          </h2>
          <p className="mt-6 max-w-md text-base leading-relaxed text-stone" data-id="element-192" data-mp="5fm3l5k3gtfr">
            Notre service réglementaire prépare la documentation dont vos affaires réglementaires ont besoin pour le
            DIP et le CPSR. Pas de relance, pas d'attente.
          </p>
          <div className="mt-10 hidden aspect-[5/4] overflow-hidden rounded-2xl lg:block" data-id="element-193" data-mp="1ut8s21qkluen">
            <img src={images.lab} alt="Flacons d'échantillons au laboratoire de contrôle" className="h-full w-full object-cover" data-id="element-194" data-mp="qi4ngefg94pj" />
          </div>
        </div>

        <div className="lg:col-span-6 lg:col-start-7 lg:pt-4" data-id="element-195" data-mp="gkzy65qb4t4i">
          <ul className="border-t border-ink" data-id="element-196" data-mp="gmujhl5hqn94">
            {qualityDocuments.map(doc => <li key={doc.name} className="flex items-baseline justify-between gap-6 border-b border-line py-6" data-id="element-197" data-mp="lk32tp2dkxby">
                <span className="font-display text-2xl text-ink md:text-[1.75rem]" data-id="element-198" data-mp="19brq2r0cavm1">{doc.name}</span>
                <span className="shrink-0 text-right text-sm text-stone" data-id="element-199" data-mp="1eacruuv8pncl">{doc.detail}</span>
              </li>)}
          </ul>
          <div className="mt-10 grid gap-8 sm:grid-cols-2" data-id="element-200" data-mp="14hx9hwg16wr6">
            <div data-id="element-201" data-mp="14gcfc7xmpftu">
              <p className="text-sm font-medium text-ink" data-id="element-202" data-mp="1s8jfli6h66yj">Échantillons sous 72 h</p>
              <p className="mt-2 text-sm leading-relaxed text-stone" data-id="element-203" data-mp="1s6gjqhin5jlw">
                Jusqu'à 5 références gratuites par projet, issues du lot qui vous sera livré.
              </p>
            </div>
            <div data-id="element-204" data-mp="26sm57dqd5sjj">
              <p className="text-sm font-medium text-ink" data-id="element-205" data-mp="21w5au1skmhy0">Développement sur-mesure</p>
              <p className="mt-2 text-sm leading-relaxed text-stone" data-id="element-206" data-mp="1xua7krr2xuhl">
                Chémotype spécifique, assemblage ou contrat de culture dès 200 kg par an.
              </p>
            </div>
          </div>
          <Link to="/qualite" className="mt-10 flex items-center gap-2 text-sm font-medium text-terracotta hover:text-terracotta-dark" data-id="element-207" data-mp="1nvuisvfiyxb9">
            Qualité &amp; réglementaire <ArrowRightIcon className="h-4 w-4" data-id="element-208" data-mp="1j3b2hqpgdo2r" />
          </Link>
        </div>
      </div>
    </section>;
}